import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ajaxGetScsDictItems } from '@/api/api';
export default {
  name: "ScsDictSelectTag",
  props: {
    dictCode: String,
    placeholder: String,
    triggerChange: Boolean,
    disabled: Boolean,
    value: [String, Number],
    type: String
  },
  data: function data() {
    return {
      dictOptions: [],
      tagType: ""
    };
  },
  created: function created() {
    console.log(this.dictCode);

    if (!this.type || this.type === "list") {
      this.tagType = "select";
    } else {
      this.tagType = this.type;
    } //获取字典数据


    this.initDictData();
  },
  methods: {
    initDictData: function initDictData() {
      var _this = this;

      //根据字典Code, 初始化字典数组
      ajaxGetScsDictItems(this.dictCode, null).then(function (res) {
        if (res.success) {
          //                console.log(res.result);
          _this.dictOptions = res.result;
        }
      });
    },
    handleInput: function handleInput(e) {
      var val;

      if (this.tagType == "radio") {
        val = e.target.value;
      } else {
        val = e;
      }

      console.log(val);

      if (this.triggerChange) {
        this.$emit('change', val);
      } else {
        this.$emit('input', val);
      }
    },
    setCurrentDictOptions: function setCurrentDictOptions(dictOptions) {
      this.dictOptions = dictOptions;
    },
    getCurrentDictOptions: function getCurrentDictOptions() {
      return this.dictOptions;
    }
  }
};